import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  // https://vuetifyjs.com/en/customization/breakpoints/
  breakpoints: {
    xs: 414,
    sm: 600,
    md: 960,
    ml: 1264 - 16, // Vuetify 2.x says -16px for desktop values
    lg: 1904 - 16,
    xl: Infinity,
  },
  defaultBreakpoint: 'sm', // customize this for SSR
})
